import { logError } from 'client/javascript/util/logger';
import { trackInteraction } from 'client/javascript/analytics';

const BROWSE_BY_WORKSPACE_MODULE_SELECTOR = '.browse-by-workspace';
export const ANALYTICS = {
  interactions: {
    itemClick: {
      selector: '[data-analytics-selector="item"]',
      label: 'Click - Browse by Workspace'
    },
    ctaLinkClick: {
      selector: '.analytics-cta-link',
      label: 'Click - View All Solutions'
    }
  }
};

export function setupBrowseByWorkspaceModuleSection() {
  try {
    const moduleElements = document.querySelectorAll(BROWSE_BY_WORKSPACE_MODULE_SELECTOR);
    if (moduleElements.length) {
      setupModuleAnalytics(moduleElements);
    }
  } catch (error) {
    logError(`[Shared modules] setupBrowseByWorkspaceModuleSection failed: ${error.message}`, error);
  }
}

function setupModuleAnalytics(moduleElements) {
  moduleElements.forEach((module) => {
    const items = module.querySelectorAll('[data-analytics-selector="item"]');
    items.forEach((item) => {
      item.addEventListener('click', ({ currentTarget }) => {
        trackInteraction({
          label: ANALYTICS.interactions.itemClick.label,
          toPath: currentTarget.href,
          selectionName: currentTarget.dataset.analyticsNonLocalizedLabel
        });
      });
    });

    // There is a separate cta link for desktop and mobile in each module
    const ctaLinks = module.querySelectorAll(ANALYTICS.interactions.ctaLinkClick.selector);
    ctaLinks.forEach((link) => {
      link.addEventListener('click', ({ currentTarget }) => {
        trackInteraction({
          label: ANALYTICS.interactions.ctaLinkClick.label,
          toPath: currentTarget.href
        });
      });
    });
  });
}
